/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * the status of a subscription
 * @export
 */
export const SubscriptionStatus = {
    Created: 'CREATED',
    Suspended: 'SUSPENDED',
    OutstandingBalance: 'OUTSTANDING_BALANCE',
    Active: 'ACTIVE',
    Cancelled: 'CANCELLED',
    Inactive: 'INACTIVE',
    Revoked: 'REVOKED',
    Upcoming: 'UPCOMING',
    ActiveButCancelledForUpcoming: 'ACTIVE_BUT_CANCELLED_FOR_UPCOMING',
    Prorated: 'PRORATED'
} as const;
export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];


export function SubscriptionStatusFromJSON(json: any): SubscriptionStatus {
    return SubscriptionStatusFromJSONTyped(json, false);
}

export function SubscriptionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStatus {
    return json as SubscriptionStatus;
}

export function SubscriptionStatusToJSON(value?: SubscriptionStatus | null): any {
    return value as any;
}

